import React from 'react'
import "./MainPageBody.css"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function MainPageBody() {
    const image= "https://www.bybit.com/common-static/fhs/bybit-home-new/products-8-20221026.png"
  return (
    <div className='MainPageBody'>
        <div className='MainPageBody_container'>
            <p>Metaverse and NFTs .</p>
            <LazyLoadImage effect='blur' src={image} className="web_image" alt='' />
        </div>
    </div>
  )
}

export default MainPageBody
